import BaseModel from '../../../../base/base_model';
import _ from '../../../../utils/underscore';
import {KEY_NAME} from '../../native/native_const';
import {SCHEME} from './url_scheme_consts';



class UrlSchemeModel extends BaseModel {

    static CLASS = 'UrlSchemeModel';


    _bundleId = '';
    _featureData = '';
    _featueName = '';

    /*
     * init the params to be an json object.
     * @params is string from web.config
     * @params is json object from html
     */
    init(params) {
        super.init(params);
    }

    checkData(data) {

        if (undefined !== data[KEY_NAME.DATA]) {
            return data;
        }

        data = _.safeJSONandDecode(data);

        return data[KEY_NAME.DATA];
    }

    /**
     * setInfoUrlScheme - that function is called each time when the app is hybrid is called by the url scheme
     * and the UrlSchcme class call the currect feature with the data.
     * example data:
     * info:{\"hybridcbfeaturefunc\":\"UrlSchemeFeature\",\"id\":\"com.hybridcgp.rl\",\"data\":\"com.hybridcgp.rl://%7B%22type%22%3A%22HybridInfoFeature%22%2C%22action%22%3A%22debug%22%2C%22url%22%3A%22https%3A%2F%2Fcasino-devtouch.888sport.com%3A82%22%2C%22reload%22%3A%22true%22%7D\"}"
     * casheir:{\"hybridcbfeaturefunc\":\"UrlSchemeFeature\",\"id\":\"com.hybridcgp.rl\",\"data\":\"com.hybridcgp.rl://%7b%22type%22%3a%22webviewmanagerfeature%22%2c%22action%22%3a%22closesafari%22%2c%22webid%22%3a1000%7d\"}
     */
    setInfoUrlScheme(data) {

        let jsonData = data;

        if (undefined !== jsonData && undefined !== jsonData[KEY_NAME.ID]) {
            this._bundleId = jsonData[KEY_NAME.ID];
            let allData = jsonData[KEY_NAME.DATA];
            this._setfeatureName(allData);
        }
    }


    /**
     * set feature Name - tparse the feature name from the url scheme
     * example data info: com.hybridcgp.rl://%7B%22type%22%3A%22HybridInfoFeature%22%2C%22action%22%3A%22debug%22%2C%22url%22%3A%22https%3A%2F%2Fmirage-cgp-client.888sport.com%22%2C%22reload%22%3A%22true%22%7D
     * */
    _setfeatureName(data) {
        if (undefined !== data) {
            let res = data.split('://');
            this._featureData = res[1];
            let tmpData = _.safeJSONandDecode(res[1]);
            this._featueName = tmpData[KEY_NAME.TYPE];
        }
    }

    /**
     * return the Feature Data
     * */
    getFeatureData() {
        return this._featureData;
    }

    /**
     * return the Feature Name
     * */
    getFeatueName() {
        return this._featueName;
    }


    setDeepLinkData(data, hybridService) {

        try {

            const logData = data;
            data = data.replace(SCHEME.IS_DEEP_LINK, '');

            const splitDeepLinkDataArray = data.split(SCHEME.DL_DEL);

            let deepLinkData = decodeURIComponent(splitDeepLinkDataArray[1]);

            deepLinkData = deepLinkData.split(SCHEME.DL_R_CURLY_BRACKETS)[0] + SCHEME.DL_R_CURLY_BRACKETS;

            deepLinkData = deepLinkData.replace('{','').replace('}','');

            this._featureData = encodeURIComponent('{"type":"deeplinkfeature",' + deepLinkData +  '}');
            this._featueName = SCHEME.DEEP_LINK_FEATUR_NAME;

            hybridService.logger.info('DeepLink Ok : ' + logData);

            return true;
        }
        catch (e) {
            hybridService.logger.info('DeepLink Error: ' + e.toString());

            return false;
        }
    }
}

export default UrlSchemeModel;
